import { render } from "./ReviewOrder.html?vue&type=template&id=022e767a&scoped=true"
import script from "./ReviewOrder.js?vue&type=script&lang=js"
export * from "./ReviewOrder.js?vue&type=script&lang=js"

import "./ReviewOrder.css?vue&type=style&index=0&id=022e767a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022e767a"]])

export default __exports__